import React from "react";
import { HomePage } from "pages";
import { Switch } from "react-router-dom";
import { IsPublicRoute } from "routes/isPublicRoute";


export const Routes = () => {
  return (
    <Switch>
      <IsPublicRoute
        redirectOnError="/"
        path="/"
        component={HomePage}
      />
    </Switch>
  );
};
